import Logo from 'assets/img/icons/sms-campaign-form-logo.svg?react';
import classNames from 'classnames';
import i18n from 'infrastructure/i18n';

import s from './styles.module.scss';

import type { TQuestionGroup } from 'infrastructure/interfaces';
import type { FC } from 'react';

const textMap = {
  title: {
    en: i18n.t('smsCampaign.formEngTitle'),
    es: i18n.t('smsCampaign.formEspTitle'),
  },
  text: {
    enrolled: [
      {
        en: i18n.t('smsCampaign.formEngText1'),
        es: i18n.t('smsCampaign.formEspText1'),
      },
      {
        en: i18n.t('smsCampaign.formEngText2'),
        es: i18n.t('smsCampaign.formEspText2'),
      },
      {
        en: i18n.t('smsCampaign.formEngText3'),
        es: i18n.t('smsCampaign.formEspText3'),
      },
    ],
    other: [
      {
        en: i18n.t('smsCampaign.formEngText4'),
        es: i18n.t('smsCampaign.formEspText1'),
      },
      {
        en: null,
        es: i18n.t('smsCampaign.formEspText2'),
      },
      {
        en: null,
        es: i18n.t('smsCampaign.formEspText3'),
      },
    ],
  },
} as const;

interface IHeaderBlockProps {
  lang?: 'en' | 'es';
  groupName?: TQuestionGroup;
}
const HeaderBlock: FC<IHeaderBlockProps> = ({
  lang = 'en',
  groupName = 'enrolled',
}) => {
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <Logo width={43} height={43} />
        <h5 className={s.title}>{textMap.title[lang]}</h5>
      </div>
      <div className={s.divider} />
      <div className={s.body}>
        {textMap.text[groupName].map((item, i) => {
          if (!item[lang]) return null;

          const className = [s.text];
          if (i === 2) className.push(s.bold, s.black);

          return (
            <p
              key={i}
              className={classNames(...className)}
              dangerouslySetInnerHTML={{ __html: item[lang] ?? '' }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HeaderBlock;
